import React from 'react';
import AdminSidebar from '../../components/AdminSidebar';

export default function AdminLayout({ children, title }) {
  return (
    <div className="flex min-h-screen bg-gray-50">
      <AdminSidebar />
      <main className="flex-1 p-6 w-full max-w-full overflow-x-hidden">
        <header className="mb-6 flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-semibold text-gray-800">{title || 'Admin Dashboard'}</h1>
            <p className="text-sm text-gray-500">Manage events, approvals, reports and system settings.</p>
          </div>
          <div className="flex items-center gap-3">
            <input className="px-3 py-2 rounded-lg border" placeholder="Search events, users..." />
            <button className="px-3 py-2 rounded bg-blue-600 text-white">New Event</button>
          </div>
        </header>

        <section className="bg-white rounded-lg shadow-sm p-6">
          {children}
        </section>

        
      </main>
    </div>
  );
}
